import React from 'react'
import PropTypes from 'prop-types'
import { Label, Input } from 'components/qstrap'
import classnames from 'classnames'

export const Checkbox = ({
  className,
  children,
  ...props
}) => {
  const isDisabled = props.disabled ? 'disabled' : ''
  return (
    <Label className={classnames('checkbox p-0', className, isDisabled)}>
      <Input
        type="checkbox"
        {...props}
      />
      <div className="checkbox-indicator" />
      {children}
    </Label>
  )
}

Checkbox.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
}
